import * as z from "zod/v4";

const teamInfoSchema = z.object({
  teamId: z.string(),
  teamName: z.string(),
  logoUrl: z.string().optional(),
  storeUrl: z.string().optional(),
});

export const verifyEmailOtp = {
  name: "verifyEmailOtp" as const,
  input: z.object({
    email: z.string().email(),
    otpId: z.string(),
    passcode: z.string(),
    teamId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    authToken: z.string().optional(),
    error: z.string().optional(),
    teams: z.array(teamInfoSchema).optional(),
  }),
};
